import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '@api/custom-services/user.service';
import { tap } from 'rxjs/operators';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
   const snackBar = inject(MatSnackBar);
   const userService = inject(UserService);

   const token = userService.getUserToken();
   if (token) {
      request = request.clone({
         setHeaders: {
            Authorization: `Bearer ${token}`,
         },
      });
   }

   return next(request).pipe(
      tap({
         next: () => {},
         error: (err) => {
            if (err?.error?.statusCode === 401) {
               userService.logout();
            }

            snackBar.open(`Something went wrong! ${err?.error?.message || 'Unknown error'}`, 'OK');
         },
      })
   );
};
